/**
 * Platform brand — the single source of truth for product identity.
 *
 * Change the values here (and the logo in ./BrandMark.tsx, plus the color
 * tokens in src/index.css) to rebrand the entire admin app. Nothing else should
 * hardcode the product name.
 *
 * NOTE: technical identifiers (widget mount ids, localStorage keys, CSS class
 * prefixes like `acw-`, the `ai-copilot-*` DOM ids) are intentionally NOT
 * derived from here — renaming those would break live embeds and persisted
 * state. They are implementation details, not branding.
 */
export interface BrandConfig {
  /** Product name shown in UI (e.g. page titles, sign-in, sidebar). */
  name: string;
  /** Short form for tight spaces. */
  shortName: string;
  /** One-line positioning statement. */
  tagline: string;
  /** Legal entity name for footers / legal copy. */
  legalName: string;
  /** Support contact surfaced in the UI. */
  supportEmail: string;
  /** Marketing site URL. */
  url: string;
}

export const BRAND: BrandConfig = {
  name: 'Orlenn',
  shortName: 'Orlenn',
  tagline: 'AI technical support agents',
  legalName: 'Orlenn',
  supportEmail: 'support@orlenn.com',
  url: 'https://orlenn.com',
};
